<!--
 * @Descripttion: 
 * @version: 0.0.1
 * @Author: ZHJI
 * @Date: 2019-10-23 15:19:58
 * @LastEditors: ZHJI
 * @LastEditTime: 2019-10-23 16:45:46
 -->
<template>
<div class="top-news">
  <span @click="openFunZNX">
    <i class="fa fa-bell"></i>
    <font :class=hide></font>
  </span>
</div>
</template>

<script>

export default {
  name: 'TopNews',
  data() {
    return {
      hide: ''
    }
  },
  created() {},
  mounted() {
    this.getCountUnRead()
  },
  computed: {
  },
  props: [],
  methods: {
    getCountUnRead: function() {
      this.$http.get('/message/read/countUnRead').then(response => {
        if (response.data > 0) {
          this.hide = ''
        } else {
          this.hide = 'hide'
        }
      }
      ).catch(
        error => {
          if (error.msg) { this.$message.error(error.msg) } else { this.$message.error(error.message) }
        }
      )
    },
    openFunZNX: function() {
      this.$router.push({ name: '未读消息' })
    }
  },
  components: {}
}
</script>

<style lang="scss" scoped>
.hide {
  display: none;
}
font {
    width: 8px;
    height: 8px;
    background-color: red;
    border-radius: 100%;
    position: absolute;
    top: 23px;
    right: 0px;
}
</style>
